import { Bed } from '../types';

export type BedOccupancySummary = {
  totalBeds: number;
  occupiedBeds: number;
  availableBeds: number;
  occupancyPct: string;
};

/** Count only active beds (matches Rooms & Beds UI and fixed analytics API). */
export function computeBedOccupancyFromList(beds: Bed[]): BedOccupancySummary {
  const active = beds.filter((b) => b.isActive !== false);
  const totalBeds = active.length;
  const occupiedBeds = active.filter((b) => String(b.bedStatus).toUpperCase() === 'OCCUPIED').length;
  const availableBeds = Math.max(0, totalBeds - occupiedBeds);
  const occupancyPct = totalBeds > 0 ? ((occupiedBeds / totalBeds) * 100).toFixed(0) : '0';
  return { totalBeds, occupiedBeds, availableBeds, occupancyPct };
}
